import { EMPTY_OBJECT } from 'commons-ui';
import { USER_SEGMENT_RESOURCES, URL } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]}/create`
				});
			};
		default:
			return () => {
				return null;
			};
	}
};
